import React, { JSX } from 'react';

import {
    BusinessAccount,
    PersonalAccount,
    PersonalAccountProps,
} from './account';
import { Organisation } from '@finn-no/organisation-http-client';

export interface AccountListProps {
    organisations: Organisation[];
    profile?: PersonalAccountProps;
    track?: (name: string, variable?: number) => void;
}

export default function AccountList(props: AccountListProps): JSX.Element {
    const { organisations, profile, track } = props;

    organisations.sort((a, b) => {
        if (a.active) {
            return -1;
        }

        if (b.active) {
            return 1;
        }

        return a.displayName.localeCompare(b.displayName);
    });

    return (
        <>
            {profile && <PersonalAccount {...profile} track={track} />}
            {Array.isArray(organisations) &&
                organisations.map((organisation: Organisation) => (
                    <BusinessAccount
                        key={organisation.orgId}
                        orgId={organisation.orgId}
                        market={organisation.market}
                        active={organisation.active || false}
                        displayName={organisation.displayName}
                        track={track}
                    />
                ))}
        </>
    );
}
